import { type DeveloperCMS } from "@repo/common/src/types/firestore/cms/developer";
import { CMSCollections } from "@repo/common/src/types/firestore/collections";
import { StoragePaths } from "@repo/common/src/types/storage/storagePaths";
import { buildCollection, buildEntityCallbacks, buildProperty, type EntityOnSaveProps } from "@firecms/core";

import { Groups } from "./types";
import { standardPermissions } from "../utils/constants";
import { loadingOverlay } from "../utils/loadOverlay";

const callbacks = buildEntityCallbacks({
  onPreSave: async (props: EntityOnSaveProps<DeveloperCMS>) => {
    loadingOverlay.show();
    const { values } = props;
    return values;
  },
  onSaveSuccess: async () => {
    loadingOverlay.hide();
  },
  onSaveFailure: async () => {
    loadingOverlay.hide();
  },
});

export const developers = buildCollection<DeveloperCMS>({
  id: CMSCollections.Developers,
  name: "Entwickler",
  singularName: "Entwickler",
  path: CMSCollections.Developers,
  icon: "People",
  group: Groups.Contributor,
  subcollections: [],
  permissions: () => {
    return standardPermissions;
  },
  callbacks,
  properties: {
    name: {
      name: "Name",
      validation: { required: true },
      dataType: "string",
    },
    description: {
      name: "Beschreibung",
      multiline: true,
      dataType: "string",
      columnWidth: 300,
      validation: { required: true },
    },
    image: buildProperty({
      name: "Image",
      description: "Bild des Entwicklers. Bitte in 512x512 hochladen.",
      dataType: "string",
      validation: { required: true },
      storage: {
        storagePath: StoragePaths.DevelopersImages,
        acceptedFiles: ["image/*"],
        maxSize: 1 * 1024 * 1024, // 1 MB in bytes
        imageCompression: {
          maxHeight: 512,
          maxWidth: 512,
        },
      },
    }),
    instagram: {
      name: "Instagram handle",
      dataType: "string",
      validation: { required: false },
      description:
        "Instagram handle des Autors. Bitte nicht die ganze URL eintragen, sondern nur den handle. z.B. @maxmustermann",
    },
    website: {
      name: "Website",
      dataType: "string",
      url: true,
      validation: { required: false },
      description: "Website des Autors",
    },
    created_on: buildProperty({
      name: "Erstellungsdatum",
      dataType: "date",
      autoValue: "on_create",
    }),
    updated_on: buildProperty({
      name: "Aktualisierungsdatum",
      dataType: "date",
      autoValue: "on_update",
    }),
  },
});
